export const actionTypes = {
    SET_NAME: 'SET_NAME',
    SET_EMAIL: 'SET_EMAIL',
    SET_POPUP: 'SET_POPUP'
};
